

































































































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import { maskDateTime, formatDateGetApi } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'

@Component
export default class ComponentModalGeracaoRepasses extends Vue {
  $refs!: { formGerarRepasse: any }

  menuAnoMesReferenciaGeracaoRepasse: boolean = false
  menuAnoMesReferenciaDoRepasse: boolean = false
  menuDataVencimentoGeracaoRepasse: boolean = false
  loadGerarRepasses: boolean = false
  isModalOpen: boolean = false

  formGerarRepasseRules: any = {
    valid: true,
    fontePagadoraGerarRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    anoMesReferenciaDoRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    condicaoPagamentoGerarRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    dataVencimentoGeracaoRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    estabelecimentoGerarRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    anoMesReferenciaGeracaoRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    getDateTime: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get modalGerarRepasse() { return this.getFinanceiroStore.modal.gerarRepasse }
  set modalGerarRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'gerarRepasse', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get loadingGerarRepasses() {
    return this.loadGerarRepasses
  }

  set loadingGerarRepasses(value: boolean) {
    this.loadGerarRepasses = value
  }

  get getFontePagadoraGerarRepasse() {
    return this.getFinanceiroStore.fontePagadoras
  }

  set getFontePagadoraGerarRepasse(value: any[]) {
    this.getFinanceiroStore.setFontePagadora(value)
  }

  get getGerarRepassePrestadores() {
    return this.getFinanceiroStore.prestadoresLista
  }

  set getGerarRepassePrestadores(value: any[]) {
    this.getFinanceiroStore.setPrestadoresLista(value)
  }

  get fontePagadoraGerarRepasse() {
    return this.getFinanceiroStore.fontePagadoraId
  }

  set fontePagadoraGerarRepasse(value: string) {
    this.getFinanceiroStore.setFontePagadoraGerarRepasse(value)
  }

  get estabelecimentoGerarRepasse() {
    return this.getFinanceiroStore.estabelecimentoGerarRepasseId
  }

  set estabelecimentoGerarRepasse(value: string) {
    this.getFinanceiroStore.setEstabelecimentoGerarRepasse(value)
  }

  get prestadorGerarRepasse() {
    return this.getFinanceiroStore.prestadorGerarRepasse
  }

  set prestadorGerarRepasse(value: string) {
    this.getFinanceiroStore.setPrestadorGerarRepasse(value)
  }

  get condicaoPagamentoGerarRepasse() {
    return this.getFinanceiroStore.condicaoPagamentoGerarRepasseId
  }

  set condicaoPagamentoGerarRepasse(value: string) {
    this.getFinanceiroStore.setCondicaoPagamentoGerarRepasseId(value)
  }

  get getCondicaoPagamento() {
    return this.getFinanceiroStore.condicoesPagamento
  }

  set getCondicaoPagamento(value: any[]) {
    this.getFinanceiroStore.setCondicaoPagamento(value)
  }

  get getMenuAnoMesReferenciaGeracaoRepasse() {
    return this.menuAnoMesReferenciaGeracaoRepasse
  }

  set getMenuAnoMesReferenciaGeracaoRepasse(value: boolean) {
    this.menuAnoMesReferenciaGeracaoRepasse = value
  }

  get getMenuAnoMesReferenciaDoRepasse() {
    return this.menuAnoMesReferenciaDoRepasse
  }

  set getMenuAnoMesReferenciaDoRepasse(value: boolean) {
    this.menuAnoMesReferenciaDoRepasse = value
  }

  get anoMesReferenciaGeracaoRepasse() {
    return this.getFinanceiroStore.anoMesReferenciaGeracaoRepasse
  }

  set anoMesReferenciaGeracaoRepasse(value) {
    this.getFinanceiroStore.setAnoMesReferenciaGeracaoRepasse(value)
  }

  get anoMesReferenciaDoRepasse() {
    return this.getFinanceiroStore.anoMesReferenciaDoRepasse
  }

  set anoMesReferenciaDoRepasse(value) {
    this.getFinanceiroStore.setAnoMesReferenciaDoRepasse(value)
  }

  get getMenuAnoMesReferenciaDataVencimentoGeracaoRepasse() {
    return this.menuDataVencimentoGeracaoRepasse
  }

  set getMenuAnoMesReferenciaDataVencimentoGeracaoRepasse(value: boolean) {
    this.menuDataVencimentoGeracaoRepasse = value
  }

  get dataVencimentoGeracaoRepasse() {
    return this.getFinanceiroStore.dataVencimentoGeracaoRepasse
  }

  set dataVencimentoGeracaoRepasse(value) {
    this.getFinanceiroStore.setDataVencimentoGeracaoRepasse(value)
  }

  get getDateTime(): Date | null {
    return formatDateGetApi(this.getFinanceiroStore.dataEnvioNotaFiscalGeracaoRepasse)
  }

  set getDateTime(value: Date | null) {
    let formatDate: string = ''
    if (value) {
      formatDate = moment(value).format('YYYY-MM-DDTHH:mm')
    }

    this.getFinanceiroStore.setDataEnvioNotaFiscalGeracaoRepasse(formatDate)
  }

  @Watch('getDateTime')
  onGetDateTimeChanged(value: Date | null) {
    if (value) {
      this.isModalOpen = true
    }
  }

  get textFieldProps() {
    return { prependIcon: 'event' }
  }

  get datePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
    }
  }

  get timePickerProps() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      allowedMinutes: m => m % 5 === 0,
    }
  }

  closeModalGerarRepasse() {
    this.getFinanceiroStore.clearGeracaoRepasses()
    this.isModalOpen = false
    this.modalGerarRepasse = false
  }

  async gerarRepasses() {
    if (this.$refs.formGerarRepasse.validate()) {
      this.loadingGerarRepasses = true
      const response = await this.getFinanceiroStore.gerarRepasses()
      if (response.success) {
        await this.getFinanceiroStore.getGeracaoRepasseAll()
        EventBus.$emit('setSnackbar', { show: true, text: 'Repasses gerados com sucesso!', icon: 'done', color: '#2E7D32' })
        this.closeModalGerarRepasse()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao gerar os repasses.', icon: 'warning', color: '#C62828' })
      }
      this.loadingGerarRepasses = false
    }
  }

  @Watch('modalGerarRepasse')
  onModalGerarRepasseChange(value: boolean) {
    if (!value) {
      this.$refs.formGerarRepasse.resetValidation()
    }
  }
}
